<template lang="pug">
#modal-insercao-resultados
    el-dialog(
        :title='dialogTitle',
        width='500px',
        top='5vh',
        :visible='show',
        @close='closeDialog'
    )
        p.mb-1 {{ $t('laudos.solicitante') }}: {{ rowInfo.usuarioSolicitacaoNome }}
        p.mb-1(v-if='rowInfo.informacaoLaudo.nomeTerritorio') {{ $t('laudos.territorio') }}: {{ rowInfo.informacaoLaudo.nomeTerritorio }}

        p.mb-1(v-if='rowInfo.informacaoLaudo.nomeRepresentante') {{ $t('laudos.pessoa') }}: {{ rowInfo.informacaoLaudo.nomeRepresentante }}

        p.mb-1(
            v-if='rowInfo.informacaoLaudo.car && rowInfo.informacaoLaudo.car.codigo'
        ) {{ $t('laudos.car') }}: {{ rowInfo.informacaoLaudo.car.codigo }}

        div(
            v-if='rowInfo.informacaoLaudo.carsVinculadosCodigos && rowInfo.informacaoLaudo.carsVinculadosCodigos.length > 0'
        )
            p.mb-1 {{ $t('laudos.cars') }}:
            ul
                li(
                    v-for='(car, index) in rowInfo.informacaoLaudo.carsVinculadosCodigos',
                    :key='index'
                )
                    span {{ car }}
        hr

        h4.font-weight-bold(v-if='showRadioOptions') {{ $t('laudos.resultadoDaAnalise') }}
        .d-flex.flex-column.py-3
            el-radio(
                v-model='radio',
                v-for='option in radioOptions',
                :label='option.value'
            ) {{ option.label }}
        div(v-if='isConformidadeAmbientalCar')
            h4.font-weight-bold.py-3 {{ $t('laudos.uploadDeInsumos.declarados') }}
            el-upload.upload-demo(
                action='#',
                drag,
                :file-list='fileListInsumosDeclarados',
                :auto-upload='false',
                :on-change='onLoadFileInsumosDeclarados',
                :on-remove='onRemoveFileInsumosDeclarados',
                ref='upload'
            )
                i.el-icon-upload
                .el-upload__text.w-100 {{ $t('laudos.arrasteArquivoAqui.1') }}<em>{{ $t('laudos.arrasteArquivoAqui.2') }}</em>

            h4.font-weight-bold.py-3 {{ $t('laudos.uploadDeInsumos.classificados') }}
            el-upload.upload-demo(
                action='#',
                drag,
                :file-list='fileListInsumosClassificados',
                :auto-upload='false',
                :on-change='onLoadFileInsumosClassificados',
                :on-remove='onRemoveFileInsumosClassificados',
                ref='upload'
            )
                i.el-icon-upload
                .el-upload__text.w-100 {{ $t('laudos.arrasteArquivoAqui.1') }}<em>{{ $t('laudos.arrasteArquivoAqui.2') }}</em>
        div(v-else)
            h4.font-weight-bold.py-3 {{ $t('laudos.uploadDeResultado') }}
            el-upload.upload-demo(
                action='#',
                drag,
                :file-list='fileList',
                :limit='1',
                :on-exceed='handleExceed',
                :auto-upload='false',
                accept='.pdf',
                :on-change='onLoadFile',
                :on-remove='onRemoveFile',
                ref='upload'
            )
                i.el-icon-upload
                .el-upload__text.w-100 {{ $t('laudos.arrastePdf.1') }} <em>{{ $t('laudos.arrastePdf.2') }}</em>

        .d-flex.flex-direction.justify-content-between.py-3
            el-button(slot='footer', size='mini', @click='closeDialog') {{ $t('mensagens.comuns.voltar') }}
            el-button(
                slot='footer',
                size='mini',
                type='primary',
                @click='inserirResultado',
                :disabled='inserindoResultado'
            ) {{ $t('mensagens.comuns.finalizar') }}
</template>

<script>
import LaudosService from '@/modules/laudos/services/LaudosService';
import StatusLaudo from '@/constants/StatusLaudo';
import TipoLaudo from '@/constants/TipoLaudo';

export default {
    name: 'ModalInsercaoResultados',

    props: {
        show: {
            type: Boolean,
            required: true
        },
        rowInfo: {
            type: Object,
            required: true
        },
        tipoLaudo: {
            type: Number,
            required: true
        }
    },

    data() {
        return {
            radio: null,
            arquivoComResultado: null,
            fileList: [],
            radioOptions: [],
            showRadioOptions: false,
            dialogTitle: this.$t('laudos.informarResultadosLaudo'),
            fileListInsumosDeclarados: [],
            fileListInsumosClassificados: [],
            listaArquivoInsumosDeclarados: [],
            listaArquivoInsumosClassificados: [],
            msgError: '',
            inserindoResultado: false
        };
    },

    computed: {
        isConformidadeAmbientalCar() {
            return this.tipoLaudo === TipoLaudo.CONFORMIDADE;
        }
    },

    methods: {
        closeDialog() {
            this.clearFields();
            this.$emit('update:show', false);
        },

        async inserirResultado() {
            this.inserindoResultado = true;
            if (this.isConformidadeAmbientalCar) {
                if (!this.listaArquivoInsumosDeclarados.length) {
                    this.$notify.error({
                        message: this.$t(
                            'laudos.arquivoDeInsumosDeclaradosObrigatorio'
                        )
                    });
                    return;
                }

                if (!this.listaArquivoInsumosClassificados.length) {
                    this.$notify.error({
                        message: this.$t(
                            'laudos.arquivoDeInsumosClassificadosObrigatorio'
                        )
                    });
                    return;
                }

                let list = [
                    ...this.listaArquivoInsumosDeclarados,
                    ...this.listaArquivoInsumosClassificados
                ];

                const promises = Promise.all(
                    list.map(async value => {
                        await this.salvarResultado(
                            this.rowInfo.id,
                            value.tipoInsumo,
                            value.raw,
                            value.name
                        );
                    })
                );

                this.msgError = '';

                promises
                    .then(() => {
                        if (this.msgError !== '') {
                            this.$notify.error({
                                message: this.msgError,
                                dangerouslyUseHTMLString: true
                            });
                            return false;
                        }

                        this.$notify.success({
                            message: this.$t(
                                'laudos.resultadosAdicionadosComSucesso'
                            )
                        });
                        this.closeDialog();
                        this.$emit('update:lista', false);

                        this.msgError = '';
                    })
                    .catch(() => {
                        this.$notify.error({
                            message: this.$t(
                                'laudos.erro.ocorreuUmErroAoAdicionarResultadoInsumosDeclarados'
                            )
                        });
                        this.msgError = '';
                    })
                    .finally(() => {
                        this.inserindoResultado = false;
                    });
            } else {
                if (!this.arquivoComResultado) {
                    this.$notify.error({
                        message: this.$t(
                            'laudos.arquivoComResultadoObrigatorio'
                        )
                    });
                    return;
                }

                let laudoId = this.rowInfo.id;
                let status = this.radio
                    ? StatusLaudo[this.radio.toUpperCase()]
                    : StatusLaudo['NAO_APLICADO'];
                if (this.tipoLaudo === TipoLaudo.RENOVABIO) {
                    status = this.radio;
                }

                let serviceMethod =
                    this.tipoLaudo === TipoLaudo.RENOVABIO
                        ? LaudosService.uploadResultadoLaudoRenovabio.bind(
                              LaudosService
                          )
                        : LaudosService.uploadResultadoLaudo.bind(
                              LaudosService
                          );

                await serviceMethod(this.arquivoComResultado, laudoId, status)
                    .then(response => {
                        if (response.status === 200) {
                            this.$notify.success({
                                message: this.$t(
                                    'laudos.resultadoAdicionadoComSucesso'
                                )
                            });
                            this.closeDialog();
                            this.$emit('update:lista', false);
                        } else {
                            this.$notify.error({
                                message: this.$t(
                                    'laudos.ocorreuUmErroAoAdicionarResultado'
                                )
                            });
                        }
                    })
                    .catch(error => {
                        this.$notify.error({
                            message: error.response.data
                        });
                    })
                    .finally(() => {
                        this.inserindoResultado = false;
                    });
            }
        },

        async salvarResultado(id, tipoInsumo, arquivo, nome) {
            await LaudosService.uploadResultadoConformidade(
                id,
                tipoInsumo,
                arquivo
            )
                .then(response => {
                    if (response.status !== 200) {
                        this.msgError +=
                            `<br> ${this.$t(
                                'laudos.erro.naoFoiPossivelEnviarArquivoSemFinal'
                            )} ` +
                            nome +
                            '. ' +
                            response +
                            ' </br>';
                    }
                })
                .catch(error => {
                    this.msgError +=
                        `<br> ${this.$t(
                            'laudos.erro.naoFoiPossivelEnviarArquivoSemFinal'
                        )} ` +
                        nome +
                        '. ' +
                        error.response.data +
                        ' </br>';
                });
        },

        onLoadFile(file, fileList) {
            this.arquivoComResultado = file;
        },

        onLoadFileInsumosDeclarados(file, fileList) {
            const isZip = file.raw.type === 'application/x-zip-compressed';
            if (!isZip) {
                fileList.pop();
                this.$notify.warning({
                    message: this.$t('laudos.erro.tipoDeArquivoNaoPermitido')
                });
            } else {
                file.tipoInsumo = 'DECLARADOS';
                this.listaArquivoInsumosDeclarados.push(file);
            }
        },

        onLoadFileInsumosClassificados(file, fileList) {
            const nomesPermitidos = [
                'vegetacao_nativa.zip',
                'vegetacao_nativa_app.zip',
                'area_antropizada.zip',
                'uso_consolidado.zip',
                'reserva_legal.zip',
                'hidrografia.zip',
                'app_total.zip',
                'app_recompor.zip',
                'app_degradada.zip'
            ];

            if (nomesPermitidos.includes(file.name)) {
                file.tipoInsumo = 'CLASSIFICADOS';
                this.listaArquivoInsumosClassificados.push(file);
            } else {
                fileList.pop();
                this.$notify.warning({
                    message: this.$t(
                        'laudos.erro.nomeOuTipoArquivoForaDoPadrao'
                    )
                });
            }
        },

        onRemoveFile(file, fileList) {
            _.remove(this.arquivosUploads, o => {
                return o.uid === file.id;
            });
        },

        onRemoveFileInsumosDeclarados(file) {
            _.remove(this.listaArquivoInsumosDeclarados, o => {
                return o.uid === file.uid;
            });
        },

        onRemoveFileInsumosClassificados(file) {
            _.remove(this.listaArquivoInsumosClassificados, o => {
                return o.uid === file.uid;
            });
        },

        handleExceed() {
            this.$notify.warning(this.$t('laudos.limiteDeUmArquivoPdf'));
        },

        clearFields() {
            this.radio = null;
            this.fileList = [];
            this.fileListInsumosDeclarados = [];
            this.fileListInsumosClassificados = [];
            this.listaArquivoInsumosDeclarados = [];
            this.listaArquivoInsumosClassificados = [];
        },

        setRadioOptions() {
            const options = {
                default: [],
                [TipoLaudo.TECNICO_AGRICOLA]: [
                    {
                        value: 'conforme',
                        label: this.$t('laudos.conforme')
                    },
                    {
                        value: 'inconforme',
                        label: this.$t('laudos.inconforme')
                    }
                ],
                [TipoLaudo.BACEN_FISCALIZACAO]: [
                    {
                        value: 'conforme',
                        label: this.$t('laudos.conforme')
                    },
                    {
                        value: 'inconforme',
                        label: this.$t('laudos.inconforme')
                    }
                ],
                [TipoLaudo.BENFEITORIAS]: [
                    {
                        value: 'conforme',
                        label: this.$t('laudos.conforme')
                    },
                    {
                        value: 'inconforme',
                        label: this.$t('laudos.inconforme')
                    },
                    {
                        value: 'inconclusivo',
                        label: this.$t('laudos.inconclusivo')
                    }
                ],
                [TipoLaudo.RENOVABIO]: [
                    {
                        value: true,
                        label: this.$t('laudos.elegivel')
                    },
                    {
                        value: false,
                        label: this.$t('laudos.inelegivel')
                    }
                ],
                [TipoLaudo.RELATORIO_TERRITORIAL]: [
                    {
                        value: 'conforme',
                        label: this.$t('laudos.conforme')
                    },
                    {
                        value: 'inconforme',
                        label: this.$t('laudos.inconforme')
                    },
                    {
                        value: 'inconclusivo',
                        label: this.$t('laudos.inconclusivo')
                    }
                ],
                [TipoLaudo.ANALISE_DE_COBERTURA_DE_SOLO]: [
                    {
                        value: 'conforme',
                        label: this.$t('laudos.conforme')
                    },
                    {
                        value: 'inconforme',
                        label: this.$t('laudos.inconforme')
                    },
                    {
                        value: 'inconclusivo',
                        label: this.$t('laudos.inconclusivo')
                    }
                ],
                [TipoLaudo.PARCERIA_SUSTENTAVEL_RASTREABILIDADE]: [
                    {
                        value: 'conforme',
                        label: this.$t('laudos.conforme')
                    },
                    {
                        value: 'inconforme',
                        label: this.$t('laudos.inconforme')
                    }
                ]
            };

            this.radioOptions = options[this.tipoLaudo] || options.default;
            this.showRadioOptions = !!this.radioOptions.length;
        }
    },

    watch: {
        tipoLaudo: 'setRadioOptions'
    },

    created() {
        this.setRadioOptions();
    }
};
</script>

<style lang="scss">
#modal-insercao-resultados {
    .el-dialog__footer {
        margin-top: -30px;
        display: flex;
        justify-content: flex-start;
    }

    .el-upload,
    .el-upload--text,
    .el-upload-dragger {
        width: 100%;
    }
}
</style>
